// Chunky 3D buttons — the visual signature.
// Ported from design_handoff_ballingo/ui.jsx.

import { BALL } from '../theme.js';

export function ChunkyButton({
  children, color = 'primary', size = 'lg', disabled = false,
  onClick, type = 'button', style = {}, theme = BALL,
}) {
  const t = theme;
  const c = t[color] || color;
  const cd = t[color + 'Deep'] || color;
  const h = size === 'lg' ? 56 : size === 'md' ? 46 : 38;
  const fs = size === 'lg' ? 17 : size === 'md' ? 15 : 13;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        appearance: 'none', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
        background: disabled ? t.locked : c,
        color: disabled ? t.lockedInk : '#fff',
        height: h, padding: '0 22px',
        borderRadius: 14,
        boxShadow: disabled ? 'none' : `0 4px 0 ${cd}`,
        fontWeight: 800, fontSize: fs, letterSpacing: '0.04em',
        textTransform: 'uppercase',
        fontFamily: 'inherit',
        transition: 'transform 80ms, box-shadow 80ms',
        ...style,
      }}
      onPointerDown={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = 'translateY(3px)';
        e.currentTarget.style.boxShadow = `0 1px 0 ${cd}`;
      }}
      onPointerUp={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = '';
        e.currentTarget.style.boxShadow = `0 4px 0 ${cd}`;
      }}
      onPointerLeave={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = '';
        e.currentTarget.style.boxShadow = `0 4px 0 ${cd}`;
      }}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, onClick, type = 'button', style = {}, theme = BALL, size = 'lg' }) {
  const t = theme;
  const h = size === 'lg' ? 56 : 46;
  return (
    <button
      type={type}
      onClick={onClick}
      style={{
        appearance: 'none', cursor: 'pointer',
        background: 'transparent',
        border: `2px solid ${t.hairline}`,
        color: t.inkSoft,
        height: h, padding: '0 22px',
        borderRadius: 14,
        boxShadow: `0 3px 0 ${t.hairline}`,
        fontWeight: 800, fontSize: 15, letterSpacing: '0.04em',
        textTransform: 'uppercase', fontFamily: 'inherit',
        ...style,
      }}
    >
      {children}
    </button>
  );
}
